import { Post, Get, Delete } from "../Request/Api";

export default {
  state: {
    eventAndStudyByGroup: [],
  },
  getters: {
    GetEventAndStudyByGroup(state: any) {
      return state.eventAndStudyByGroup;
    },
  },
  actions: {
    async CreateEventAndGroup({ commit }: any, payload: any) {
      return await Post("EventAndGroup/AddEventAndGroup", payload);
    },
    async EditEventAndGroup({ commit }: any, payload: any) {
      return await Post("EventAndGroup/EditEventAndGroup", payload);
    },
    async GetEventAndStudyByGroup({ commit }: any, payload: any) {
      return await Get(
        `EventAndGroup/GetEventAndStudyByGroup?page=1&pageSize=all&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetEventAndStudyByGroup", res.data.Data);
        return res.data.Data;
      });
    },
    async DeleteEventAndGroup({ commit }: any, payload: any) {
      return await Delete(`EventAndGroup/DeleteEventAndGroup/${payload}`);
    },
  },
  mutations: {
    SetEventAndStudyByGroup(state: any, payload: any) {
      payload.forEach((item: any) => {
        item.Data.forEach((data: any) => {
          if (data.EventDate) {
            data.customDate = new Date(data.EventDate);
          } else if (data.NextOccurrence && data.NextOccurrence.length > 0) {
            const sortedNextOccurrences = data.NextOccurrence.map(
              (dateString: any) => new Date(dateString)
            ).sort((a: any, b: any) => a.getTime() - b.getTime());

            const currentDate = new Date();
            const nextOccurrence = sortedNextOccurrences.find(
              (date: any) => date >= currentDate
            );

            if (nextOccurrence) {
              data.customDate = nextOccurrence;
            } else {
              data.customDate = null;
            }
          } else {
            data.customDate = null;
          }
        });
      });

      const filterMonthAndYear = payload.filter((item: any) => {
        try {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;

          const monthMap: { [key: string]: number } = {
            January: 1,
            February: 2,
            March: 3,
            April: 4,
            May: 5,
            June: 6,
            July: 7,
            August: 8,
            September: 9,
            October: 10,
            November: 11,
            December: 12,
          };

          const itemMonth = monthMap[item.Month];
          const itemYear = item.Year;

          if (itemYear > currentYear) {
            return true;
          } else if (itemYear === currentYear) {
            return currentMonth <= itemMonth;
          } else {
            return false;
          }
        } catch (error) {
          return false;
        }
      });

      const itemData = filterMonthAndYear.map((item: any) => {
        const filteredData = item.Data.filter((dataItem: any) => {
          if (!dataItem.EventDate) {
            const currentDate = new Date();

            // for (const givenDate of dataItem.NextOccurrence || []) {
            //     const givenDateTime = new Date(givenDate);

            //     if (givenDateTime >= currentDate) {
            //         return true;
            //     }

            const inputDate = new Date(dataItem.NextOccurrence[0]);

            if (inputDate.getFullYear() > currentDate.getFullYear()) {
                dataItem.customDate = inputDate;
              return inputDate;
            } else if (inputDate.getFullYear() === currentDate.getFullYear()) {
              if (inputDate.getMonth() > currentDate.getMonth()) {
                dataItem.customDate = inputDate;
                return inputDate;
              } else if (
                inputDate.getMonth() + 1 ===
                currentDate.getMonth() + 1
              ) {
                if (inputDate.getDate() >= currentDate.getDate()) {
                    dataItem.customDate = inputDate;
                  return inputDate;
                }
              }
              return false
            }
            return false
          }

          if (dataItem.EventDate) {
            const givenDate = new Date(dataItem.EventDate);
            const currentDate = new Date();

            currentDate.setHours(0, 0, 0, 0);
            if(givenDate >= currentDate){
                dataItem.customDate = givenDate;
                return givenDate
            }
            // return givenDate >= currentDate;
          }

          return false;
        });
        filteredData.sort((a: any, b: any) => {
          if (a.customDate && b.customDate) {
            return a.customDate.getTime() - b.customDate.getTime();
          } else if (a.customDate) {
            return -1;
          } else if (b.customDate) {
            return 1;
          }
          return 0;
        });

        return { ...item, Data: filteredData };
      });

      itemData.sort((a: any, b: any) => {
        if (a.Year !== b.Year) {
          return a.Year - b.Year;
        } else {
          const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          return months.indexOf(a.Month) - months.indexOf(b.Month);
        }
      });

      state.eventAndStudyByGroup = itemData;
    },
  },
};
